import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DEFAULT_PROVIDER, isProviderKey } from './auth.config';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth-callback',
  template: '<app-fullscreen-loading-spinner></app-fullscreen-loading-spinner>',
  standalone: false,
})
export class AuthCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private auth = inject(AuthService);
  private router = inject(Router);

  async ngOnInit(): Promise<void> {
    const candidate = this.route.snapshot.paramMap.get('provider');
    const provider = isProviderKey(candidate) ? candidate : DEFAULT_PROVIDER;

    try {
      await this.auth.init(provider);
    } catch {
      this.router.navigateByUrl('/');
    }
  }
}
